export default function LedgerPanel({ title, extra, children, className = '', bodyStyle, style }) {
  return (
    <div className={`ledger-panel ${className}`.trim()} style={style}>
      {(title || extra) && (
        <div className="ledger-panel__head" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span>{title}</span>
          {extra}
        </div>
      )}
      <div className="ledger-panel__body" style={bodyStyle}>
        {children}
      </div>
    </div>
  )
}
